import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/tents.json";
import fr from "@/locales/fr/puzzle-types/tents.json";

export const TENTS_NS = "puzzle-types/tents";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerTentsTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", TENTS_NS))
    i18n.addResourceBundle("en", TENTS_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", TENTS_NS))
    i18n.addResourceBundle("fr", TENTS_NS, fr, true, true);
}
